import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { ListPlus } from 'lucide-react';
import { useCourseData } from '@/pages/Course';
import { useCourses } from '@/features/course/hooks/useCourses';

function AddTopic({ unitId }) {
  const { course, isAdmin } = useCourseData();
  const { updateCourses } = useCourses();
  const [visible, setVisible] = useState(false);
  const [topicName, setTopicName] = useState('');
  const [covers, setCovers] = useState('');

  const handleAddTopic = async () => {
    if (!topicName.trim()) return;

    const updatedUnits = course.units.map((unit) => {
      if (unit._id === unitId) {
        return {
          ...unit,
          topics: [...unit.topics, { name: topicName, cover: covers }],
        };
      }
      return unit;
    });

    const updatedCourse = {
      units: updatedUnits,
    };

    try {
      await updateCourses.mutateAsync({
        id: course._id,
        updatedData: updatedCourse,
      });

      // Reset form
      setVisible(false);
      setTopicName('');
      setCovers('');
    } catch (error) {
      console.error('Error adding topic:', error);
    }
  };

  return (
    <>
      {isAdmin && (
        <>
          {visible ? (
            <>
              <Input
                className="mb-1"
                value={topicName}
                onChange={(e) => setTopicName(e.target.value)}
                placeholder="Enter topic name"
              />
              <Input
                className="mb-1"
                value={covers}
                onChange={(e) => setCovers(e.target.value)}
                placeholder="Topics it should cover"
              />
              <div className="flex gap-2">
                <Button onClick={() => setVisible(false)} size="sm">
                  Cancel
                </Button>
                <Button onClick={handleAddTopic} size="sm">
                  Submit
                </Button>
              </div>
            </>
          ) : (
            <Button variant="brand" className="w-full" onClick={() => setVisible(true)} size="sm">
              <ListPlus /> Add a topic
            </Button>
          )}
        </>
      )}
    </>
  );
}

export default AddTopic;
